import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { clearConfigsSchema } from '@api/schemaConfig';

import { IOnSuccess } from '@interfaces/common/handlers';

import { refetchOptions } from '@constants/common';
import { CLEAR_CONFIGS_SCHEMA, MAVENIR_SCHEMA_CONFIG } from '@constants/queryKeys';

interface IClearConfigsReturnType {
	isLoadingClearConfigs: boolean;
	clearConfigs: () => void;
}

const useMutateClearConfigs = (props?: IOnSuccess): IClearConfigsReturnType => {
	const queryClient = useQueryClient();

	const { onSuccess } = props || {};

	const {
		mutate: clearConfigs,
		isLoading,
	} = useMutation({
		mutationKey: [CLEAR_CONFIGS_SCHEMA],
		mutationFn: clearConfigsSchema,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [
				queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG]),
			];
		},
		...refetchOptions,
	});

	return {
		clearConfigs,
		isLoadingClearConfigs: isLoading,
	};
};

export default useMutateClearConfigs;
